<div *ngIf="post">
    <div style="width: 500px">
      <img style="width: 100%" [src]="apiUrl+'/assets/'+post.image"
           alt="{{post.title}}">
    </div>
    <h2>{{post.title}}</h2>
    <p>{{post.content}}</p>
  </div>
